.button {
  font-family: var(--titles-font), serif;
  font-weight: 800;
  font-size: var(--h5-font-size);
  line-height: 120%;
  letter-spacing: 0.01em;
  border-radius: var(--rounded-heavy);
  color: white;
  padding: 1.2rem 3.2rem;
  transition-duration: 0.2s;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  position: relative;
}

.button.gradient {
  background: var(--button-gradient);
  box-shadow: 6px 4px 10px 5px inset #33323238, inset -3px -2px 1rem #a9a9a973, -1px -1px 2px 0px #6f6f6f38, 3px 3px 3px #00000029, 1px 1px 1px inset #ffffff61 !important;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
  transition-duration: 0.3s;  
}

.button.gradient:hover {
  box-shadow: inset 6px 4px 10px 5px #d1cfcf38, inset -3px -2px 2rem #33323273, -2px -2px 2px #ffffff1f, 3px 3px 3px #00000029, 1px 1px 1px inset #ffffff61 !important;
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.5);
}

.button.outline {
  background: transparent;
  box-shadow: 0 0 0 0.2rem white inset;
}

.button.outline:hover {
  background: var(--horizontal-gradient);
  color: white;
  font-weight: 800;
  box-shadow: 0 0 0 0 white inset;
}

.button.small {
  font-size: inherit;
  padding: 0.6rem 1.3rem;
  display: flex;
  align-items: center;
}

.button.disabled {
  opacity: 0.5
}

.canvas {
  position: absolute;
  top:0;
  left:0;
}